import styled from '@emotion/styled'
import { Box, Modal } from '@mui/material';
import { Colors } from '../../../../../colors';

export const ModalStyled = {
  StyledModal: styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  StyledBox: styled(Box)`
    padding: 18px;
    background: #fff;
    min-height: 250px;
    margin: 20px;
    display: flex;
    flex-direction: column;
    //align-items: center;
    justify-content: space-between;
    text-align: center;
    color: #f44336;
  `,
  Title: styled.span`
    font-family: EncodeSans-Bold;
    font-size: 20px;
    color: ${Colors.Black};
    margin-top: 32px;
    margin-bottom: 25px;
  `,
  Description: styled.span`
    font-family: EncodeSans-Medium;
    font-size: 16px;
    word-break: break-word;
    color: ${Colors.Black};
    margin-bottom: 20px;
  `,
  Separator: styled.div<any>`
    height: 15px;
  `,
  TextFieldContainer: styled.div<any>`
    width: 100%;
  `,
  ContainerButton: styled.div<any>`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  ContainerContent: styled.div<any>`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  `,
  ContainerCloseButton: styled.div<any>`
    display: flex;
    align-self: end;
    justify-self: end;
  `,
  Button: styled.div<any>`
    min-width: 178px;
  `,
};
